import React from "react"
import { Col, Row } from "reactstrap"
import { SaveButton } from "components/Buttons"

const ErrorMessageModal = ({ onClose, message }) => {
  return (
    <React.Fragment>
      <Row>
        <h6>Oops...</h6>
      </Row>
      <Row>
        <p>{message || "Something went wrong! Please try again!"}</p>
      </Row>
      <Row className="justify-content-end">
        <Col xs={3}>
          <SaveButton content="OK" fullWidth={true} onClick={onClose} />
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default ErrorMessageModal
